<template>
	<b-navbar toggleable="lg" :sticky="true">
		<b-container fluid>
			<div class="align-items-center mh-navbar-logo">
				<b-navbar-brand @click="showPage('DashboardContent')"><img src="../../assets/images/logo.png" alt="Mopane Health"></b-navbar-brand>
				<icon name="sign-out-alt" scale="2" class="hidden-md-up ml-auto mr-3 logout" title="logout" @click="logout"></icon>
				<b-navbar-toggle class="hidden-md-up m-0" target="sidebar" title="Toggle responsive left sidebar" @click="toggleMenu" />
			</div>
			<div class="mh-topright">
				<a href="#" class="mh-topright-clock">
					<i>
						<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M11 6V11H16" stroke="#E94A79" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z" stroke="#081E4A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</i>
					{{ timestamp }}
				</a>

				<div class="w-25 d-inline-block float-left" style="padding:17px;">
					<i class="mh-icon-calendar mr-3" style="font-size:1.5em;"></i>
					<a href="#" style="font-weight:bold;">
						{{`${moment(this.currentPeriodDate).format("DD MMM")} - ${moment(this.currentPeriodDate).add(-1, "days").add(2, "weeks").format("DD MMM")}`}}
					</a>
				</div>

				<b-dropdown v-if="isEmployee"
							size="lg"
							variant="link"
							toggle-class="text-decoration-none"
							:class="`mh-topright-notification${(notifications.length > 0 ? '' : ' disabled')}`"
							ref="notificationDropdown"
							@show="toggleNotificationDropdown"
							right
							no-caret>
					<template slot="button-content">
						<i>
							<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M16.9301 10C17.5426 15.3755 19.9474 17 19.9474 17H1C1 17 4.15789 14.8667 4.15789 7.4C4.15789 5.70261 4.82331 4.07475 6.00775 2.87452C7.19219 1.67428 8.79863 1 10.4737 1C10.8287 1 11.1807 1.0303 11.5263 1.08949" stroke="#081E4A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M17.8421 7C19.5862 7 21 5.65685 21 4C21 2.34315 19.5862 1 17.8421 1C16.098 1 14.6842 2.34315 14.6842 4C14.6842 5.65685 16.098 7 17.8421 7Z" stroke="#E94A79" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M12.2948 20C12.1097 20.3031 11.8441 20.5547 11.5244 20.7295C11.2049 20.9044 10.8425 20.9965 10.4737 20.9965C10.1049 20.9965 9.74254 20.9044 9.42296 20.7295C9.10338 20.5547 8.8377 20.3031 8.65265 20" stroke="#081E4A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							<b-badge v-if="notifications.length > 0" variant="danger" pill>{{notifications.length}}</b-badge>
						</i>
					</template>

					<b-dropdown-text v-if="notifications.length > 0" class="notification">
						<b-row class="m-0">
							<b-col class="text-right">
								<b-button variant="warning" @click="markNotificationRead" size="sm">Mark All Read</b-button>
							</b-col>
						</b-row>
					</b-dropdown-text>
					<b-dropdown-text v-for="(notification, index) in notifications" :key="index" class="notification">
						<b-row class="m-0 mb-2">
							<b-col class="title">{{notification.name}}</b-col>
							<b-col class="date text-right" align-self="center">{{moment(notification.date, "DD/MM/YYYY h:mm:ss A").format("DD-MM-YYYY")}}</b-col>
						</b-row>
						<b-row class="m-0 mb-2">
							<b-col class="shift">{{notification.shift}}</b-col>
						</b-row>
						<b-row class="m-0">
							<b-col class="time">{{notification.shifttime}}</b-col>
						</b-row>
						<b-dropdown-divider v-if="index != notifications.length - 1"></b-dropdown-divider>
					</b-dropdown-text>
				</b-dropdown>

				<b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" class="mh-topright-profile" right no-caret>
					<template slot="button-content">
						<ProfileImage :imageUrl="profilePicture" />
						<span>
							{{profile.email}}
							<small>{{profile.fullname}}</small>
						</span>
					</template>

					<b-dropdown-item href="#" @click="logout" style="width: 270px;">Logout</b-dropdown-item>
				</b-dropdown>
			</div>
		</b-container>
	</b-navbar>
</template>

<script>
	import ProfileImage from "./ProfileImage"
	import moment from "moment"

	export default {
		name: 'Header',
		components: {
			ProfileImage
		},
		data: function () {
			return {
				timestamp: ""

			}
		},
		mounted: function () {
			this.$store.dispatch("Intervals/set", { name: "HeaderGetNow", callback: this.getNow, timeout: 1000 })
		},
		destroyed: function () {
			this.$store.commit("Intervals/clear", "HeaderGetNow")
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			notifications: function () {
				return this.$store.state.Notifications.notifications.filter(x => x.read == 0)
			},
			isEmployee: function () {
				return this.profile.accounttype == 2
			},
			profilePicture: function () {
				return this.profile.profilepic
			},
			currentPeriodDate: function () {
				return this.$store.state.Shifts.date
			}
		},
		methods: {
			getNow: function () {
				this.timestamp = moment().format('hh : mm  : ss A');
			},
			logout: function () {
				this.$store.dispatch("Profile/logout")
			},
			markNotificationRead: function () {
				var $this = this

				this.$store.dispatch("Notifications/setNotificationsRead").then(function () {
					$this.$store.dispatch("Notifications/getNotifications")
					$this.$refs.notificationDropdown.hide()
				})
			},
			toggleNotificationDropdown: function () {
				if (this.notifications.length < 1)
					this.$refs.notificationDropdown.hide()
			},
			showPage: function (content) {
				this.$store.dispatch("Content/show", content)

				localStorage.content = content
			},
			toggleMenu: function () {
				this.$root.$emit("toggle-menu")
			}
		}
	};
</script>

<style scoped>
	.navbar {
		overflow: visible;
	}

	.notification {
		width: 500px;
	}

		.notification .title {
			font-weight: bold;
		}

		.notification .date {
			font-size: 13px;
			font-weight: normal;
		}

		.notification .shift {
			font-size: 13px;
		}

		.notification .time {
			font-size: 13px;
			font-weight: normal;
		}
</style>